<template>
  <el-descriptions>
    <slot name="before"></slot>
    <el-descriptions-item label="订单税率：">{{ detail.orderTaxRate }}%</el-descriptions-item>
    <el-descriptions-item label="单价(未税)：">{{ priceWithoutRate(detail.orderFee, detail.amount, true, detail.orderTaxRate) }}</el-descriptions-item>
    <el-descriptions-item label="单价(含税)：">{{ $currency(detail.orderFee) }}</el-descriptions-item>
    <el-descriptions-item label="总价(未税)：">{{ totalPriceWithoutRate(detail.orderFee, detail.amount, true, detail.orderTaxRate) }}</el-descriptions-item>
    <el-descriptions-item label="总价(含税)：">{{ numberTimes(detail.orderFee, detail.amount, true) }}</el-descriptions-item>
    <slot name="after" />
  </el-descriptions>
</template>
<script lang="ts">
import { defineComponent, reactive, toRefs, watch } from 'vue'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils'
export default defineComponent({
  name: 'AccountPreview',
  props: {
    detail: { type: Object, required: true, default: () => null }
  },
  setup(props) {
    const dataMap = reactive({
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),

      priceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => priceWithoutRate(price, isCurrency, rate),

      totalPriceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => totalPriceWithoutRate(price, amount, isCurrency, rate)
    })

    watch(() => props.detail, () => {
      // da
      console.log(props.detail, 'props.account')
    })
    return { ...toRefs(dataMap) }
  }

})
</script>
